import { useRouter } from 'next/router';
import React from 'react';

import ListPageStates from '@/src/shared/components/ListPage/ListPageStates';
import useListSearch from '@/src/shared/hooks/useListSearch';
import states from '@/utils/states';

const searchOptions = {
  pubCode: 521,
  yearsBack: 5,
};

const RegulatoryTrackingReport = props => {
  const router = useRouter();
  const { statecode } = props;
  const _statecode = statecode || router.query.slug || 0;
  const [loading, results] = useListSearch(searchOptions, _statecode);

  return (
    <ListPageStates
      title="Regulatory Tracking Report"
      heroContent={<p>Documents from the last 5 years</p>}
      results={results}
      truncateResultSummary
      searchOptions={searchOptions}
      statecode={_statecode}
      loading={loading}
      titlePrefix=""
      routeBase="/compliance/legislative-regulatory-activity/regulatory-tracking-report"
    />
  );
};

export async function getStaticPaths() {
  return {
    paths: states.map(s => ({ params: { slug: s.StateCode } })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      statecode: params.slug || 0,
    },
  };
}

export default RegulatoryTrackingReport;
